import { useState } from 'react'
import { useAuth } from 'ict24h-themes-react'
import {
  BodyUpdateProjectIdWithInputInput,
  ProjectEntity,
} from '../../../../../server-api-hrm.type'
import commonRequestHandler from '../../../../../utils/common-request-handler'
import requestErrorHandler from '../../../../../utils/request-error-handler'
import { updateProject } from '../project.service'
import { setMenuRefetchSignal } from '../stores/project-reducer'

type RequestFailType = 'SERVER' | 'RESOURCE' | 'OTHER'

type Params = {
  onFinish?: (_res: ProjectEntity) => void
  onFail?: (_failType: RequestFailType) => void
  customRequestHandler?: boolean
}

const useUpdateProject = (params: Params = {}) => {
  const { token } = useAuth()

  const [loading, setLoading] = useState(false)

  const handleUpdate = async (
    body: BodyUpdateProjectIdWithInputInput,
    localHandler: Params = {}
  ) => {
    const onFinish = localHandler?.onFinish || params.onFinish
    const onFail = localHandler?.onFail || params.onFail
    const customRequestHandler =
      localHandler?.customRequestHandler ?? params.customRequestHandler

    const requestHandler = customRequestHandler
      ? requestErrorHandler
      : commonRequestHandler

    setLoading(true)
    const res = await updateProject(token, body)
    setLoading(false)
    if (!res) {
      if (typeof onFail === 'function') onFail('OTHER')
      return
    }
    requestHandler({
      status: res?.status,
      action: 'mutate',
      onSuccess: () => {
        if (typeof onFinish === 'function') onFinish(res.data)
        setMenuRefetchSignal({
          type: res.data?.departmentId
            ? 'DEPARTMENT_PROJECT'
            : 'GENERAL_PROJECT',
          action: 'U',
        })
      },
      onResourceFail: () => {
        if (typeof onFail === 'function') onFail('RESOURCE')
      },
      onServerFail: () => {
        if (typeof onFail === 'function') onFail('SERVER')
      },
    })
  }

  return {
    loading,
    handleUpdate,
  }
}

export default useUpdateProject
